/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=d9848cb8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wuxieshuan/Desktop/上海印高/WeCom_FE/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/header-search/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9848cb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9848cb8', __exports__)) {
    console.log('reload')
    api.reload('d9848cb8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=d9848cb8", () => {
    console.log('re-render')
    api.rerender('d9848cb8', render)
  })

}


export default __exports__